import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Detail from "../router/detail/Detail";

function SubPage() {
  return (
    <>
      <Header></Header>
      <Switch>
        <Route path="/detail/:nation/:page/:id">
          <Detail></Detail>
        </Route>
      </Switch>
      <Footer></Footer>
    </>
  );
}

export default SubPage;
